import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './Button.module.scss';

type SubmitButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset'; // Para garantir que seja um botão de submit
  className?: string; // Para adicionar classes personalizadas
  disabled?: boolean; // Para desabilitar o botão se necessário
};

const SubmitButton: React.FC<SubmitButtonProps> = ({ onClick, children, disabled, className, type = 'submit' }) => {
  return (
    <Button
      variant="primary"
      type={type}
      className={`${styles['submit-button']} ${className || ''}`}
      onClick={onClick}
      disabled={disabled} // Desabilita o botão se a prop disabled for true
    >
      {children || 'Enviar'}
    </Button>
  );
};

export default SubmitButton;
